export const deleteHighLights = () => {
  document.addEventListener('touchstart', () => {}, true)
}
